import styled from 'styled-components'

import { blocksWidth, sideMargins } from '../constants'

export const Block = styled.div`
    height: 30px;
    cursor: pointer;
    transition: all 0.2s;
    ${props => {
        const { activity, dataLen, color } = props
        return `
        margin: 5px ${sideMargins}px;
        width: ${(activity * blocksWidth(dataLen)) / 100}px;
        background: ${color};`
    }}
    &:hover {
        transform: scaleY(1.1);
    }
`
